import { render, staticRenderFns } from "./recruitList.vue?vue&type=template&id=8715ab16&scoped=true"
import script from "./recruitList.vue?vue&type=script&lang=js"
export * from "./recruitList.vue?vue&type=script&lang=js"
import style0 from "./recruitList.vue?vue&type=style&index=0&id=8715ab16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715ab16",
  null
  
)

export default component.exports